import { useNavigate, useLocation } from 'react-router-dom'
import { useWorkspace } from '../../../../../contexts/WorkspaceContext.tsx'
import { useAppDispatch } from '../../../../../store/hooks.ts'
import { setMobileSidebarOpen } from '../../../../../store/ui/uiSlice.ts'
import PlateIcon from '../../../../../assets/icons/icon-plate.svg?react'
import SidebarUiButton from '../SidebarUiButton/SidebarUiButton.tsx'
import Tooltip from '@/components/ui/Tooltip/Tooltip'

const SidebarPlateButton = () => {
    const dispatch = useAppDispatch()
    const navigate = useNavigate()
    const location = useLocation()
    const { workspace } = useWorkspace()

    const isActive = workspace && location.pathname === `/${workspace.workspaceUrlId}/my-tasks`

    const handleClick = () => {
        if (workspace) {
            navigate(`/${workspace.workspaceUrlId}/my-tasks`)
            dispatch(setMobileSidebarOpen(false))
        }
    }

    return (
        <Tooltip title="My tasks">
            <SidebarUiButton icon={<PlateIcon />} title="My tasks" isActive={!!isActive} onClick={handleClick} />
        </Tooltip>
    )
}

export default SidebarPlateButton
